"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _applications = require("./utils/applications");
var _identity = require("./utils/identity");
var _ClientApplicationModal = _interopRequireDefault(require("./ClientApplicationModal"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ClientApplicationModalController = function ClientApplicationModalController(props) {
  var config = (0, _exchangeReactHooks.useConfig)();
  var profile = (0, _exchangeReactHooks.useProfile)();
  var context = (0, _exchangeReactHooks.useSessionContext)();
  var masterOrganizationId = profile.organization.id;
  var handleGetGrantTypes = function handleGetGrantTypes(params) {
    return (0, _identity.getGrantTypes)(_objectSpread({
      config: config,
      context: context,
      masterOrganizationId: masterOrganizationId
    }, params));
  };
  var handleUpdateClientApplication = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(params) {
      var application;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _applications.updateClientApplication)(_objectSpread({
              config: config,
              context: context,
              masterOrganizationId: masterOrganizationId
            }, params));
          case 2:
            application = _context.sent;
            _context.next = 5;
            return props.onEditApplication(application);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleUpdateClientApplication(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var handleCreateClientApplication = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee2(params) {
      var application;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _applications.createClientApplication)(_objectSpread({
              config: config,
              context: context,
              masterOrganizationId: masterOrganizationId
            }, params));
          case 2:
            application = _context2.sent;
            _context2.next = 5;
            return props.onCreateApplication(application);
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleCreateClientApplication(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react.default.createElement(_ClientApplicationModal.default, (0, _extends2.default)({}, props, {
    onCreateApplication: handleCreateClientApplication,
    onEditApplication: handleUpdateClientApplication,
    onGetGrantTypes: handleGetGrantTypes
  }));
};
ClientApplicationModalController.defaultProps = {
  application: null,
  className: null,
  onCreateApplication: function onCreateApplication() {},
  onEditApplication: function onEditApplication() {}
};
ClientApplicationModalController.modalName = 'ClientApplicationModal';
var _default = exports.default = ClientApplicationModalController;
//# sourceMappingURL=ClientApplicationModalController.js.map